






















import { Component, Prop, Vue } from "vue-property-decorator";
import { Element } from "@api/models/Element";
import { getImageUrl } from "@common/ImageUrlHelper";

@Component({
    name: "EventEditPartner"
})
export default class EventEditPartner extends Vue {
    @Prop() partner: Element;
    @Prop({ default: () => [] }) selectedPartnersIds: string[];

    get title() {
        return this.partner.title || '';
    }

    get parentTitle() {
        return this.partner.parentId?.title || '';
    }

    get logoUrl() {
        if (this.partner.iconFileId) {
            return getImageUrl(this.$route.params.backend, this.partner.iconFileId, 164);
        }
        return '';
    }

    get isSelected() {
        return (this.selectedPartnersIds || []).includes(this.partner.id);
    }
}
